<div class="card-inline">
  <h3>Historia clínica</h3>
</div>
<mat-divider></mat-divider>
<mat-spinner *ngIf="loading"></mat-spinner>
<p-scrollPanel
  *ngIf="!loading"
  styleClass="scroll-panel margin-top-medium margin-botton-medium"
>
  <table
    class="search-table search-table-fixed"
    mat-table
    [dataSource]="dataSource"
  >
    <ng-container matColumnDef="DateTimeString">
      <th
        class="search-table-header resizable-column"
        mat-header-cell
        *matHeaderCellDef
      >
        Horario
      </th>
      <td class="search-table-cell" mat-cell *matCellDef="let element">
        <div>{{ element.DateTimeString }}</div>
      </td>
    </ng-container>
    <ng-container matColumnDef="PracticeRegionName">
      <th
        class="search-table-header resizable-column"
        mat-header-cell
        *matHeaderCellDef
      >
        Práctica
      </th>
      <td class="search-table-cell" mat-cell *matCellDef="let element">
        <div>{{ element.PracticeRegionName }}</div>
      </td>
    </ng-container>
    <ng-container matColumnDef="Protocol">
      <th
        class="search-table-header resizable-column"
        mat-header-cell
        *matHeaderCellDef
      >
        Protocolo
      </th>
      <td class="search-table-cell" mat-cell *matCellDef="let element">
        <div>{{ element.Protocol }}</div>
      </td>
    </ng-container>
    <!-- Star Column -->
    <ng-container matColumnDef="Star" stickyEnd>
      <th class="search-table-header" mat-header-cell *matHeaderCellDef></th>
      <td class="search-table-cell" mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menuItem">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menuItem="matMenu">
          <button (click)="medicalOrderScannView(element)" mat-menu-item>
            <mat-icon>scanner</mat-icon><span>Ver escaneos</span>
          </button>
          <button
            (click)="studyReportView(element)"
            *ngIf="element.StudyReportId"
            mat-menu-item
          >
            <mat-icon>search</mat-icon><span>Ver informe</span>
          </button>
          <button
            (click)="clinicalDataView(element)"
            *ngIf="element"
            mat-menu-item
          >
            <mat-icon>search</mat-icon
            ><span>Datos clínicos y Antecedentes</span>
          </button>
          <button
            (click)="commentPreStudyReportView(element)"
            *ngIf="element"
            mat-menu-item
          >
            <mat-icon>search</mat-icon><span>Comentarios y Preinforme</span>
          </button>

            <button
            (click)="viewPacs(element)"
            *ngIf="element.StudyReportId"
            mat-menu-item
          >
            <mat-icon>search</mat-icon><span>Ver imágenes del pacs</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>
    <tr
      mat-header-row
      class="search-table-header"
      *matHeaderRowDef="displayedColumns; sticky: true"
    ></tr>
    <tr
      mat-row
      class="search-table-cell"
      *matRowDef="let row; columns: displayedColumns"
    ></tr>
  </table>
</p-scrollPanel>
